import { createGetTextResources } from "../../utils/text-resources-algemeen";

export const saveButtonTextResources = createGetTextResources({
    TryAgain: "Opslag mislukt. Probeer nogmaals.",
    Save: "Wijzigingen opslaan",
    SaveRequest: "Opslaan en aanvragen",
    Busy: "Bezig met opslaan.",
    SaveSucces: "Alle gegevens zijn opgeslagen",
    SaveSuccesRequest: "De aanvraag is verstuurd"
});